import { paymentMethodsReducer } from 'src/store/api/paymentMethods';
import { combineReducers } from '@reduxjs/toolkit';

import aside from '../api/aside';
import auth from '../api/auth';
import commission from '../api/commission';
import accountsPayment from '../api/connectedProviders/accountsPayment';
import accountsPayout from '../api/connectedProviders/accountsPayout';
import providersPayment from '../api/connectedProviders/providersPayment';
import providersPayout from '../api/connectedProviders/providersPayout';
import dicts from '../api/dicts';
import filters from '../api/filters';
import hints from '../api/hints';
import hintsSite from '../api/hintsSite';
import { merchantGroupsReducer } from '../api/merchantGroups/reducers';
import merchants from '../api/merchants';
import { paymentCommissionReducer } from '../api/paymentCommission/reducers';
import { paymentCommissionsFiltersReducer } from '../api/paymentCommissionsFilters/reducers';
import paymentLimits from '../api/paymentLimits';
import paymentOrders from '../api/paymentOrders';
import paymentRouting from '../api/paymentRouting';
import payoutAvailableMethods from '../api/payoutAvailableMethods';
import { payoutCommissionReducer } from '../api/payoutCommission/reducers';
import { payoutCommissionsFiltersReducer } from '../api/payoutCommissionsFilters/reducers';
import payoutLimits from '../api/payoutLimits';
import payoutOrders from '../api/payoutOrders';
import payoutRouting from '../api/payoutRouting';
import providersSettings from '../api/providersSettings';
import sidebar from '../api/sidebar';
import sites from '../api/sites';
import users from '../api/users';
import { apiFulfilledReducer } from '../apiFulfilled/reducers';
import { apiPendingReducer } from '../apiPending/reducers';
import { apiRejectedReducer } from '../apiRejected/reducers';

const rootReducer = combineReducers({
  apiFulfilled: apiFulfilledReducer,
  apiPending: apiPendingReducer,
  apiRejected: apiRejectedReducer,
  auth,
  aside,
  sidebar,
  providersPayment,
  providersPayout,
  merchants,
  paymentOrders,
  payoutOrders,
  payoutLimits,
  paymentLimits,
  accountsPayment,
  accountsPayout,
  paymentRouting,
  payoutRouting,
  hints,
  hintsSite,
  users,
  commission,
  payoutAvailableMethods,
  filters,
  dicts,
  providersSettings,
  sites,
  merchantGroupsReducer,
  paymentCommission: paymentCommissionReducer,
  paymentCommissionFilters: paymentCommissionsFiltersReducer,
  payoutCommission: payoutCommissionReducer,
  payoutCommissionsFilters: payoutCommissionsFiltersReducer,
  paymentMethodsReducer,
});

export default rootReducer;
